// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionWrapper_section__87_Ve","topNone":"SectionWrapper_topNone__9IrG0","bottomNone":"SectionWrapper_bottomNone__tJ8GQ"};